import HeadArea from "../box/head";
import WordListArea from "./word_list";
import FootArea from "../box/foot";
function LineTempleteArea(props: any) {
  let myProps = {
    Style: {},
    templete_data_json: {},
    ...props
  };
  let Style = myProps.Style || {};
  let templete_data_json = myProps.templete_data_json || {};

  return (
    <div className={Style.word_page_wrap} >
      <HeadArea
        Style={Style}
        templete_data_json={templete_data_json}
      ></HeadArea>
      <div className={Style.word_page_body} >
        <WordListArea
          Style={Style}
          templete_data_json={templete_data_json}
        ></WordListArea>
      </div>
      <FootArea
        Style={Style}
        templete_data_json={templete_data_json}
      ></FootArea>
    </div>
  );
};
export default LineTempleteArea;